import React, { useState } from "react";
import { AddIcon } from "../../icons";
import CreateCoursePopup from "./createPopup";
import CreatePagePopupNew from "./CreatePagePopupNew";
import {
  addSubject,
  addTopic,
  addSubtopic,
  createPageForCourse,
  createPageForSubject,
  createPageForTopic,
  createPageForSubtopic,
} from "../../helper/apicalls/course";

const ActionButtons = ({
  context, 
  courseKey,
  subjectKey,
  topicKey,
  subTopicKey,
  onCreateSuccess,
  buttonLabel,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupHeaderTitle, setPopupHeaderTitle] = useState("");
  const [popupButtonText, setPopupButtonText] = useState("");

  const handleOpenPopup = () => {
    switch (context) {
      case "course":
        setPopupTitle("Course");
        setPopupHeaderTitle("Add Course");
        setPopupButtonText("Add Course");
        break;
      case "subject":
        setPopupTitle("Subject");
        setPopupHeaderTitle("Add Subject");
        setPopupButtonText("Add Subject");
        break;
      case "topic":
        setPopupTitle("Topic");
        setPopupHeaderTitle("Add Topic");
        setPopupButtonText("Add Topic");
        break;
      case "subtopic":
        setPopupTitle("Sub Topic");
        setPopupHeaderTitle("Add Sub Topic");
        setPopupButtonText("Add Sub Topic");
        break;
      case "page":
        setIsPopupOpen(true);
        return;
      default:
        setPopupTitle("Item");
        setPopupHeaderTitle("Add Item");
        setPopupButtonText("Add");
    }

    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSave = async (value, totalNumberQuizes) => {
    try {
      let result;
      const parsedQuizzes = totalNumberQuizes ? parseInt(totalNumberQuizes, 10) : 0;

      switch (context) {
        case "subject":
          result = await addSubject({
            name: value,
            course_key: courseKey,
            total_number_quizes: parsedQuizzes,
          });
          break;
        case "topic":
          result = await addTopic({
            name: value,
            subject_key: subjectKey,
            course_key: courseKey,
            total_number_quizes: parsedQuizzes,
          });
          break;
        case "subtopic":
          result = await addSubtopic({
            name: value,
            topic_key: topicKey,
            course_key: courseKey, 
            total_number_quizes: parsedQuizzes,
          });
          break;
        default:
          console.log(`Creating ${context}:`, value);
          result = { name: value };
      }

      if (onCreateSuccess) {
        onCreateSuccess(result);
      }

      handleClosePopup();
    } catch (error) {
      console.error(`Error creating ${context}:`, error);
    }
  };

  const handleCreatePage = async (pageData) => {
    try {
      let result;

      if (subTopicKey) {
        result = await createPageForSubtopic({
          ...pageData,
          subtopic_key: subTopicKey,
          course_key: courseKey, 
        });
      } else if (topicKey) {
        result = await createPageForTopic({
          ...pageData,
          topic_key: topicKey,
          course_key: courseKey, 
        });
      } else if (subjectKey) {
        result = await createPageForSubject({
          ...pageData,
          subject_key: subjectKey,
          course_key: courseKey, 
        });
      } else if (courseKey) {
        result = await createPageForCourse({
          ...pageData,
          course_key: courseKey,
        });
      }

      if (onCreateSuccess) {
        onCreateSuccess(result);
      }

      handleClosePopup();
    } catch (error) {
      console.error("Error creating page:", error);
    }
  };

  if (context === "page") {
    return (
      <div className="action-buttons-container">
        {isPopupOpen&&<CreatePagePopupNew
          open={isPopupOpen}
          handleClose={handleClosePopup}
          onSave={handleCreatePage}
          courseKey={courseKey}
          subjectKey={subjectKey}
          topicKey={topicKey}
          subTopicKey={subTopicKey}
        />}
        <button className="action-button" onClick={handleOpenPopup}>
          <AddIcon className="action-button-icon" />
          <span>{buttonLabel || "Add Page"}</span>
        </button>
      </div>
    );
  }

  return (
    <div className="action-buttons-container">
      <button className="action-button" onClick={handleOpenPopup}>
        <AddIcon className="action-button-icon" />
        <span>
          {buttonLabel ||
            `Add ${context.charAt(0).toUpperCase() + context.slice(1)}`}
        </span>
      </button>

    { isPopupOpen && <CreateCoursePopup
        open={isPopupOpen}
        handleClose={handleClosePopup}
        title={popupTitle}
        headerTitle={popupHeaderTitle}
        buttonText={popupButtonText}
        onSave={handleSave}
      />}
    </div>
  );
};

export default ActionButtons;
